/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Rule_CountInputs */

const en_tables_rule_sets_rule_count = /** @type {(inputs: Tables_Rule_Sets_Rule_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Rule Count`)
};

const de_tables_rule_sets_rule_count = /** @type {(inputs: Tables_Rule_Sets_Rule_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Regeln`)
};

/**
* | output |
* | --- |
* | "Sets Rule Count" |
*
* @param {Tables_Rule_Sets_Rule_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_rule_count = /** @type {((inputs?: Tables_Rule_Sets_Rule_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Rule_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_rule_count(inputs)
	return de_tables_rule_sets_rule_count(inputs)
});